import React from 'react'
import { apiFetch } from '../utils/apiClient'; // ✅ import your reusable fetch hel

const FichierExcelRh = ({nomformulaire, startDate, endDate}) => {
      const handleDownload = async () => {
  try {
    const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/downloadExcelRh`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            nomformulaire,
            startDate,
            endDate,
          }),
        }
      );
    if (response.ok) {
      const blob = await response.blob();

      // Try to extract filename from Content-Disposition header
      const disposition = response.headers.get('Content-Disposition');
      let filename = 'Export.xlsx';

      if (disposition) {
  const match = disposition.match(/filename="?([^"]+)"?/);
  if (match && match[1]) {
    filename = match[1];
  }
}

      // Trigger the download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Erreur lors du téléchargement du fichier');
    }
  } catch (err) {
    console.error('Erreur lors de la requête de téléchargement', err);
  }
};
      return (
        <div>
          <button
  onClick={handleDownload}
  disabled={(nomformulaire === "AEFO" || nomformulaire === "FEESO" || nomformulaire === "SCFP" || nomformulaire === "rapport de police")&& (!startDate || !endDate)}
  className={`text-sm px-6 py-2 font-semibold rounded-lg shadow-md transition duration-200
    ${ (nomformulaire === "AEFO" || nomformulaire === "FEESO" || nomformulaire === "SCFP" || nomformulaire === "rapport de police") && (!startDate || !endDate)
      ? "bg-gray-400 text-gray-200 cursor-not-allowed"
      : "bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
    }`}
>
            Télécharger le fichier Excel {nomformulaire} 
          </button>
        </div>
      );
}

export default FichierExcelRh